export default "__VITE_ASSET__DOaI5ELc__"